<div class="form-item case-search-item" [formGroup]="searchFormGrp">
  <mat-label class="case-label">
    <span class="required-field" *ngIf="required">*</span> {{ label }}
  </mat-label>

  <div class="single-case-field">
    <!-- Prefix Dropdown -->
    <div class="field-section prefix-section">
      <select formControlName="casePrefix" (change)="updateCombinedCaseNumber()">
        <option *ngFor="let prefix of prefixOptions" [value]="prefix">{{ prefix }}</option>
      </select>
    </div>

    <span class="field-slash-divider">/</span>

    <!-- Middle Case Input -->
    <div class="field-section middle-section">
      <input #middleInput type="text" formControlName="caseMiddle" placeholder="Case No " [matAutocomplete]="auto"
        #autocompleteTrigger="matAutocompleteTrigger" (keypress)="onMiddleKeyPress($event)"
        (paste)="onMiddlePaste($event)" (focus)="onMiddleFocus()" (click)="onMiddleClick()"
        (input)="onMiddleInput($event)" />
      <mat-icon *ngIf="caseListLoader" class="search-icon animate-spin">
        sync
      </mat-icon>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="caseDisplayFn.bind(this)"
        panelClass="case-search-autocomplete-panel" [panelWidth]="'auto'"
        (optionSelected)="onCaseOptionSelected($event)" (opened)="onPanelOpened()">
        <mat-option *ngFor="let item of caseList" [value]="item">
          {{ item.caseNumber || ''}} <span *ngIf="item.caseCatagory"> - {{ item.caseCatagory }}</span>
          <span *ngIf="item.division"> - {{ item.division }}</span>
        </mat-option>
        <mat-option *ngIf="pageLoading" class="dropdown-loader-option" disabled>
          <div class="panel-loading-wrapper">
            <mat-icon>sync</mat-icon>
            <span>Loading more...</span>
          </div>
        </mat-option>
      </mat-autocomplete>
    </div>

    <span class="field-slash-divider">/</span>

    <!-- Suffix Year Section (Dropdown or In-Place Manual Input) -->
    <div class="field-section suffix-section">
      <ng-container *ngIf="!showManualYearInput; else manualYearInputTpl">
        <select formControlName="caseSuffixYear" (change)="onSuffixYearSelect($event)">
          <option *ngFor="let year of yearOptions" [value]="year.toString()">{{ year }}</option>
          <option value="CUSTOM_YEAR">+ Add / Custom Year...</option>
        </select>
      </ng-container>
      <ng-template #manualYearInputTpl>
        <div class="manual-year-inline">
          <input type="number" formControlName="manualYear" placeholder="e.g. 2010" (blur)="confirmCustomYear()"
            (keyup.enter)="confirmCustomYear()" (input)="updateCombinedCaseNumber()" />
          <div class="manual-year-icons">
            <mat-icon class="year-action-icon" (click)="confirmCustomYear()" title="Apply Year">check</mat-icon>
            <mat-icon class="year-action-icon" (click)="cancelCustomYear()" title="Cancel">close</mat-icon>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>